/**
 * Claves de cache del back-office. Se declaran acá y no en `@/api/keys`
 * porque son de un panel que sólo existe para UN tenant; mezclarlas con las
 * de los módulos de marca invitaría a invalidarlas juntas.
 */
export const hqKeys = {
  all: ['hq'] as const,
  overview: () => [...hqKeys.all, 'overview'] as const,
  clients: (search: string) => [...hqKeys.all, 'clients', { search }] as const,
  requests: (estado: string) => [...hqKeys.all, 'requests', { estado }] as const,
  stock: (soloLibres: boolean) => [...hqKeys.all, 'stock', { soloLibres }] as const,
  supplierTool: () => [...hqKeys.all, 'supplierTool'] as const,
  staff: () => [...hqKeys.all, 'staff'] as const,
};
